import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/AuthPage.css';

const ActivationPage = () => {
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleActivation = async (e) => {
        e.preventDefault();
        setMessage('');

        if (password !== confirmPassword) {
            setMessage('Passwords do not match.');
            return;
        }

        try {
            const response = await fetch('/api/activate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token, password }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.msg);
                setTimeout(() => navigate('/login'), 3000); // Redirect to login after 3 seconds
            } else {
                setMessage(data.msg || 'Activation failed.');
            }
        } catch (error) {
            setMessage('An error occurred during activation.');
            console.error('Activation error:', error);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <h2 className="auth-title">Activate Your Account</h2>
                    <p className="auth-subtitle">Please set your password to activate your account.</p>
                </div>
                <form onSubmit={handleActivation} className="auth-form">
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Confirm Password</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="auth-button">Activate Account</button>
                </form>
                {message && <p className="auth-message">{message}</p>}
            </div>
        </div>
    );
};

export default ActivationPage;
